import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';

import HtmlPage from 'views/htmlPage/HtmlPage';
import SplitPane from 'views/splitPane/SplitPane';

import ProjectLocaleList from 'views/projectLocaleList/ProjectLocaleList';
import TranslationsListWithEditor from 'views/translationsListWithEditor/TranslationsListWithEditor';

import './translations.scss';

import projectsStore from 'storeState/projects';
import authStore from 'storeState/auth';
import URLService from 'service/URLService';

import _ from 'lodash';

class Translations extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.loadProjects();

        this.pullChanges = setInterval(() => {
            this.loadProjects();
        }, 5000);
    }

    componentWillUnmount() {
        if(this.pullChanges) {
          clearInterval(this.pullChanges);
        }
    }

    loadProjects = () => {
        this.props.actions.projectsListRequest({tenant_id: this.props.currentTenantId, loadInBackground: true});
    }

    getProject = () => {
        let project=null;
        if(this.props.projects && this.props.match.params.project_id) {
            project = _.find(this.props.projects, (p) => p.id==this.props.match.params.project_id);
        }
        return project;
    }

    getSelectedLocale = (props) => {
        let o = null;

        let project = this.getProject();
        if(props.match.params.project_locale_string_id && project) {
            o = _.find(project.locales, (l) => l.project_locale_string_id == props.match.params.project_locale_string_id);
        }
        return o;
    }

    handleLocaleClick = (val) => {

        const currentVariable = URLService.getQueryParameterAsString("variable");
        URLService.gotoPush('/translations/'+this.getProject().id+'/'+val + (currentVariable ? '?variable='+currentVariable : ''));
    }

    componentWillReceiveProps = (nextProps) => {

        if(!nextProps.match.params.project_locale_string_id) {
            const project = this.getProject();
            if(project && project.locales.length>0) {
                setTimeout(() => {
                    const localeKeys = _.sortBy(_.keys(project.locales), (k) => project.locales[k].project_locale_string_id);
                    this.handleLocaleClick(project.locales[localeKeys[0]].project_locale_string_id)
                },1000);
            }
        }

        if(nextProps.projectsLoadedTenant === nextProps.currentTenantId && !this.getProject()){
            URLService.gotoReplace('/dashboard');
        }
    }

    render() {
        const project = this.getProject();
        const locale = this.getSelectedLocale(this.props);

        if(project == null) {
            return (
                <HtmlPage className="screen-translations">

                </HtmlPage>
            );
        } else {
           return (
                <HtmlPage className="screen-translations">
                    <div className="content-translations">

                        <ProjectLocaleList
                            className="translations-locale-list"
                            project={project}
                            value={locale}
                            onLocaleClick={this.handleLocaleClick}
                        />
                        <TranslationsListWithEditor
                            className="translations-list-with-editor"
                            project={project}
                            locale={locale}
                        />
                    </div>
                </HtmlPage>
            );
        }
    }
}

export default connect((state, props) => {
    return {
        projects: projectsStore.selectors.projectsList(state),
        currentTenantId: authStore.selectors.currentTenantId(state),
        projectsLoadedTenant: projectsStore.selectors.projectsLoadedTenant(state),
    }
},(dispatch, props) => {
    return {
        actions: bindActionCreators(Object.assign({}, projectsStore.actions), dispatch)
    }
})(Translations)



// WEBPACK FOOTER //
// ./src/components/screens/translations/Translations.js